import { lazy, Suspense } from 'react';

import { Outlet } from 'react-router-dom';
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/overview'));
const TransactionsPage = lazy(() => import('src/pages/dashboard/transactions'));
const BudgetPage = lazy(() => import('src/pages/dashboard/budget'));
const ScenariosPage = lazy(() => import('src/pages/dashboard/scenarios'));
const BudgetVsActualPage = lazy(() => import('src/pages/dashboard/budget-vs-actual'));
const ActualPage = lazy(() => import('src/pages/dashboard/actual'));
const ForecastPage = lazy(() => import('src/pages/dashboard/forecast'));
const CashFlowPage = lazy(() => import('src/pages/dashboard/cashflow'));
const AccountsPage = lazy(() => import('src/pages/dashboard/accounts'));
const ContactPage = lazy(() => import('src/pages/dashboard/contact'));

const NetWorthPage = lazy(() => import('src/pages/dashboard/net-worth'));
const IncomePage = lazy(() => import('src/pages/dashboard/income'));
const ExpensesPage = lazy(() => import('src/pages/dashboard/expenses'));
const AssetsPage = lazy(() => import('src/pages/dashboard/assets'));
const LiabilitiesPage = lazy(() => import('src/pages/dashboard/liabilities'));
const ProfilePage = lazy(() => import('src/pages/dashboard/profile'));

// ----------------------------------------------------------------------

const growbread_routes = [
  { path: 'overview', element: <IndexPage />, index: true },
  { path: 'transactions', element: <TransactionsPage /> },
  { path: 'networth', element: <NetWorthPage /> },
  { path: 'income', element: <IncomePage /> },
  { path: 'expenses', element: <ExpensesPage /> },
  { path: 'assets', element: <AssetsPage /> },
  { path: 'liabilities', element: <LiabilitiesPage /> },
  { path: 'cashflow', element: <CashFlowPage /> },
];

const reports_routes = [
  {
    path: 'reports',
    children: [
      { path: 'budget', element: <BudgetPage /> },
      { path: 'actual', element: <ActualPage /> },
      { path: 'budget-vs-actual', element: <BudgetVsActualPage /> },
      { path: 'forecast', element: <ForecastPage /> },
    ],
  },
];

const settings_routes = [
  {
    path: 'settings',
    children: [
      { path: 'scenarios', element: <ScenariosPage /> },
      { path: 'accounts', element: <AccountsPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'profile', element: <ProfilePage /> },
    ],
  },
];

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [...growbread_routes, ...reports_routes, ...settings_routes],
  },
];
